// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1IRyq","title":"FrontImage_title__2PvUw"};